import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from "antd";

import { Tab } from "@hdi-seguros/web-components.tabs";

import { PreLiquidationsFilterForm, PreLiquidationTableItem } from "../../interfaces";

interface SavedAndSentPreLiquidationsContextProps {

    savedPreLiquidationsFilterForm:                 FormInstance<PreLiquidationsFilterForm>;
    sentPreLiquidationsFilterForm:                  FormInstance<PreLiquidationsFilterForm>;

    TABS_ITEMS:                                     Array<Tab>;

    isLoadingPreLiquidations:                       boolean;
    setIsLoadingPreLiquidations:                    Dispatch<SetStateAction<boolean>>;

    datasourceSavedPreliquidationsTable:            Array<PreLiquidationTableItem>;
    setDatasourceSavedPreliquidationsTable:         Dispatch<SetStateAction<Array<PreLiquidationTableItem>>>;

    datasourceSentPreliquidationsTable:             Array<PreLiquidationTableItem>;              
    setDatasourceSentPreliquidationsTable:          Dispatch<SetStateAction<Array<PreLiquidationTableItem>>>;
    
    initialDatasourceSavedPreliquidationsTable:     Array<PreLiquidationTableItem>;  
    initialDatasourceSentPreliquidationsTable:      Array<PreLiquidationTableItem>;

    getSavedPreliquidations:                        () => Promise<void>;
    getSentPreliquidations:                         () => Promise<void>;
}  

export const SavedAndSentPreLiquidationsContext = createContext({} as SavedAndSentPreLiquidationsContextProps);